// extracted by mini-css-extract-plugin
export default {"container":"P0-z","list":"Q0-z"};